<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-container class="px-6">
        <v-row>
          <v-col cols="auto" class="pa-0">
            <v-card-title>Change Filter</v-card-title>
            <v-card-subtitle>
              How would you like to filter?
            </v-card-subtitle>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn icon @click="cancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-select
                outlined
                v-model="type"
                :items="items"
                item-text="name"
                item-value="id"
                hide-details
                @change="
                  id = [];
                  setSelected(null);
                "
                label="What are you looking for?"
              ></v-select>
            </v-col>
            <v-col cols="12" v-if="type == $enums.coreCardIdTypes.MEMBER">
              <member-autocomplete
                v-model="id"
                :multiple="false"
                :rules="[$rules.requiredArrayWithoutFalsy]"
                label="Select member"
                v-on:change-full="setSelected"
              >
              </member-autocomplete>
            </v-col>
            <v-col cols="12" v-if="type == $enums.coreCardIdTypes.MANAGER">
              <member-autocomplete
                v-model="id"
                :multiple="false"
                :rules="[$rules.requiredArrayWithoutFalsy]"
                only-managers
                label="Select manager"
                v-on:change-full="setSelected"
              >
              </member-autocomplete>
            </v-col>
            <v-col cols="12" v-if="type == $enums.coreCardIdTypes.TEAM">
              <team-autocomplete
                v-model="id"
                :multiple="false"
                :rules="[$rules.requiredArrayWithoutFalsy]"
                label="Select department"
                v-on:change-full="setSelected"
              >
              </team-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-btn
                color="primary"
                :loading="saving"
                @click="save"
                :disabled="!changed"
              >
                Update Report
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TeamAutocomplete from "@/components/teams/TeamAutocomplete";
import MemberAutocomplete from "@/components/members/MemberAutocomplete";
export default {
  name: "ChangeFilterDialog",
  components: { TeamAutocomplete, MemberAutocomplete },
  props: {},
  data: () => ({
    changed: false,
    dialog: false,
    valid: false,
    saving: false,
    type: null,
    id: [],
    selected: null
  }),
  watch: {},
  computed: {
    items() {
      return [
        { id: this.$enums.coreCardIdTypes.TEAM, name: "A department" },
        { id: this.$enums.coreCardIdTypes.MANAGER, name: "A manager’s team" },
        { id: this.$enums.coreCardIdTypes.MEMBER, name: "A member" }
      ];
    },
    ...mapGetters({})
  },
  methods: {
    setSelected(selected) {
      this.selected = selected ? selected[0] : null;
      this.changed = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.getInfo());
        this.dialog = false;
      }
    },
    showDialog(filter) {
      let type = null;
      let id = null;
      if (filter.userId) {
        type = this.$enums.coreCardIdTypes.MEMBER;
        id = [this.user.id];
      } else if (this.manager) {
        type = this.$enums.coreCardIdTypes.MANAGER;
        id = this.manager.id;
      } else if (this.team) {
        type = this.$enums.coreCardIdTypes.TEAM;
        id = this.team.id;
      } else {
        type = this.$enums.coreCardIdTypes.COMPANY;
      }
      this.dialog = true;
      this.type = type;
      this.id = id ? [id] : [];
      this.changed = true;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    getInfo() {
      return {
        id: this.id.length > 0 ? this.id[0] : null,
        type: this.type,
        selected: this.selected
      };
    }
  }
};
</script>
